module.exports = __webpack_public_path__ + "static/media/jigglypuff_0.65dd944f.png";